var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isMobile)?_c('div',[_c('div',{staticClass:"contest creatbtn d-flex flex-row",staticStyle:{"cursor":"pointer"},on:{"click":_vm.clickPool}},[_c('img',{staticClass:"icon ml-lg-2",attrs:{"src":require("@/assets/image/icon_pool.png")}}),_c('span',{staticClass:"ml-0"},[_vm._v(_vm._s(_vm.$t('headerNavPool')))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }